import type { SeoMeta } from '~~/models'

export const useSeoMetaStore = defineStore('seoMeta.store', () => {
  const seoMeta = ref<SeoMeta>({
    title: '',
    keywords: '',
    description: '',
    h2: '',
  })

  function setSeoMeta(meta: SeoMeta) {
    seoMeta.value = meta
  }

  const webPage = computed(() => {
    return {
      name: seoMeta.value.title,
      description: seoMeta.value.description,
    }
  })

  return {
    setSeoMeta,
    seoMeta,
    webPage,
  }
})
